// extracted by mini-css-extract-plugin
module.exports = {"mobileAlertsButton":"AlertsButton_mobileAlertsButton__jhKXk","icon":"AlertsButton_icon__PX8Iz","chevron":"AlertsButton_chevron__S4cfp"};